import { render, staticRenderFns } from "./trade.vue?vue&type=template&id=67d1edf6&scoped=true&"
import script from "./trade.vue?vue&type=script&lang=js&"
export * from "./trade.vue?vue&type=script&lang=js&"
import style0 from "./trade.vue?vue&type=style&index=0&id=67d1edf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d1edf6",
  null
  
)

export default component.exports